import React from "react";
import logo from "../assets/logo.png";
import { Link } from 'react-router-dom';

export class Footer extends React.Component{
    constructor(){
        super();
    }
    render(){
        return (
            <div className="footer-container">
                <span className="footer-text">EmptyStudio © 2023 All Right Reserved</span>
            </div>
        )
    }
}